$(document).ready(function(){
  $(".detail_tab_title > div").click(function(e){
    // t_shipping はリンク遷移させるのでタブ処理はスキップ
    if($(this).hasClass("t_link")){
      return; // ここで処理終了 → <a>のhrefでリンク飛ぶ
    }
    
    // タブタイトルのactive切替
    $(".detail_tab_title > div").removeClass("active");
    $(this).addClass("active");

    // 対応するコンテンツのactive切替
    $(".detail_tab_d > div").removeClass("active");
    let targetClass = $(this).attr("class").split(" ")[0].replace("t_", "d_");
    $("." + targetClass).addClass("active");
  });
});



